import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAUcz9VvtnWH1mpdj_E0fvPTejuPKFdQKs",
  authDomain: "pcari-71145.firebaseapp.com",
  databaseURL: "https://pcari-71145.firebaseio.com",
  projectId: "pcari-71145",
  storageBucket: "pcari-71145.appspot.com",
  messagingSenderId: "568647603184",
  appId: "1:568647603184:web:8cfe8c98c195f65b2e4335",
  measurementId: "G-B2JP63GZMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);